import PropTypes from 'prop-types';

export const Modal = ({ children, handleClose, title = '' }) => {
  return (
    <div className="modal__overlay">
      <div className="modal">
        <div className="modal__close">
          <button className="modal__close-btn vertical-center" onClick={() => handleClose()}>
            <img src={`${process.env.PUBLIC_URL}/close-icon.svg`} alt="close" />
          </button>
        </div>
        {title && (
          <div className="modal__title">
            <h2>{title}</h2>
          </div>
        )}
        <div className="modal__body">{children}</div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string,
};
